export enum DocumentWorkflowType {
  ESIGNFLOW = 1,
  MAGDA_DIGITAL_SIGNING = 2,
  MAGDA_DOCUMENT_SERVICE = 3,
}

export class DocumentWorkflow {
  Id: number;
  DocumentId: number;
  DocumentWorkFlowTypeId: number;
  DocumentExternalId: string;
  CreationDate: Date;
}
